import { Component, OnInit, Input } from '@angular/core';
import { Entry } from 'contentful';
import { subscriptions } from 'stripe';

@Component({
  selector: 'app-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.scss']
})
export class CurrentPlanComponent implements OnInit {
  @Input() public currentSubscription: subscriptions.ISubscription | undefined;
  @Input() public content: Entry<any> | undefined;

  constructor() {}

  ngOnInit() {}
}
